// Issues services

import {
  Box,
  Module,
  Issue,
  IssuePages,
  ISSUE_TYPES
} from "types/issues.types";
import {
  genModules,
  genBoxes
} from "util/testUtils/builders/issues/module.builder";
import axiosDefault from "util/axios";
import { getAuthorization } from "redux/auth/auth.actions";
import { FetchBoxesService } from "./issues.service.types";
import { Category } from "../../../types/service.types";
import { Ticket } from "../../../types/ticket.types";
import { message } from "antd";

export const fetchModules = (roleId: number): Module[] => {
  // TODO: Replace with endpoint
  return genModules(roleId, 5);
};

export const fetchBoxes = async (
  type: string,
  assigneeId: number,
  categories?: string[]
): Promise<Box[] | undefined> => {
  try {
    const authorizationToken = await getAuthorization();
    // TODO: Separar a distintos métodos
    let filters: FetchBoxesService[] = [];
    if (
      type === ISSUE_TYPES.SUPERVISOR_ACTIVITIES ||
      type === ISSUE_TYPES.SUPERVISOR_TICKET
    ) {
      const { data } = await axiosDefault.get<FetchBoxesService[]>(
        "/api/tickets/filter/supervisor",
        {
          params: {
            categories: categories?.toString()
          },
          headers: {
            Authorization: authorizationToken
          }
        }
      );
      filters = data;
    } else {
      const { data } = await axiosDefault.get<FetchBoxesService[]>(
        "/api/tickets/filter/assignee",
        {
          params: {
            assigneeId
          },
          headers: {
            Authorization: authorizationToken
          }
        }
      );
      filters = data;
    }

    filters = filters.filter(box => box.section.toLowerCase() === type);

    return filters.map(box => {
      const { id, count, description, section } = box;
      const lSection = section.toLowerCase();
      let localCount = count;
      if (
        lSection === ISSUE_TYPES.SUPERVISOR_ACTIVITIES ||
        lSection === ISSUE_TYPES.ACTIVITIES
      ) {
        localCount = -1;
      }
      const issuePages: IssuePages = {};
      for (let i = 0; i < count; i++) {
        issuePages[i] = undefined;
      }
      return {
        ...box,
        id: id.toString(),
        description: !description ? undefined : description,
        count: localCount,
        issuePages
      };
    });
  } catch (error) {
    message.error("Ocurrió un error al cargar las bandejas");
  }
};

export const fetchIssues = async (
  moduleId: string,
  boxId: string,
  page: number,
  size: number,
  //DELETE ME LATER

  assigneeId: number,
  orderBy: string,
  valueTosearh?: string
): Promise<Issue[] | undefined> => {
  try {
    const authorizationToken = await getAuthorization();

    const pagination = {
      page: page + 1,
      size
    };
    // TODO: all this logic should be managed in a better way from the endpoint itself
    let sort = {
      predicate: orderBy === "" ? "id" : orderBy,
      type: orderBy === "priority" ? "DESC" : "ASC"
    };

    if (boxId === "2" || boxId === "3") {
      sort = {
        predicate: "id",
        type: "DESC"
      };
    }

    const { data } = await axiosDefault.get(
      `/api/tickets/ticketsByAssignee/${assigneeId}`,
      {
        params: {
          filterId: boxId,
          pagination,
          sort,
          search: valueTosearh
        },
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    const tickets = data.data;
    const formattedTickets: Ticket[] = tickets.map((ticket: any) => {
      return {
        id: ticket.id,
        // TODO: poner el valor correcto cuando ya exista esa funcionalidad
        read: true,
        responsible: {
          id: ticket.assignee.id,
          name: ticket.assignee.name
        },
        author: ticket.author ?? "Anónimo",
        subject: ticket.subject,
        flowStatus: ticket.globalStatus,
        flowStatusUpdatedAt: ticket.updatedAt,
        priority: ticket.priority,
        createdAt: ticket.createdAt,
        updatedAt: ticket.updatedAt,
        score: ticket.score,
        ...ticket
      };
    });
    return formattedTickets;
  } catch (error) {
    message.error("Ocurrió un error al cargar los tickets");
  }
};

export const fetchIssuesActivities = async (
  moduleId: string,
  box: Box,
  page: number,
  size: number,
  //DELETE ME LATER

  assigneeId: number,
  orderBy: string,
  valueTosearh?: string
): Promise<Issue[]> => {
  const boxId = box.id;
  const defaultParams = box.defaultParams ?? {};

  try {
    const authorizationToken = await getAuthorization();

    // const pagination = {
    //   page: page + 1,
    //   size
    // };
    // const sort = {
    //   predicate: orderBy === "" ? "id" : orderBy,
    //   type: orderBy === "priority" ? "DESC" : "ASC"
    // };
    // TODO: Cambiar a tickets por assignee
    const { data } = await axiosDefault.get<any>(
      `/api/tickets/ticketsByActivities?assignee=${assigneeId}`,
      {
        params: {
          ...defaultParams,
          filterId: boxId,
          search: valueTosearh
        },
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    const tickets = data.data;
    const formattedTickets: Ticket[] = tickets.map((ticket: any) => {
      return {
        id: ticket.id,
        // TODO: poner el valor correcto cuando ya exista esa funcionalidad
        read: true,
        responsible: {
          id: ticket.assignee.id,
          name: ticket.assignee.name
        },
        author: ticket.author ?? "Anónimo",
        subject: ticket.subject,
        flowStatus: ticket.globalStatus,
        flowStatusUpdatedAt: ticket.updatedAt,
        priority: ticket.priority,
        createdAt: ticket.createdAt,
        updatedAt: ticket.updatedAt,
        score: ticket.score,
        ...ticket
      };
    });
    return formattedTickets;
  } catch (error) {
    throw new Error("Failed to fetch fetchIssues");
  }
};

export const fetchTicketCategories = async (): Promise<Category[]> => {
  try {
    const authorizationToken = await getAuthorization();
    const msRoute = "/api/tickets/category";
    const { data } = await axiosDefault.get(`${msRoute}`, {
      headers: {
        Authorization: authorizationToken
      }
    });
    return data;
  } catch (e) {
    throw new Error("Failed to fetch the categories");
  }
};

export const fetchAssigneeByExternalId = async (externalId: string) => {
  try {
    const authorizationToken = await getAuthorization();
    const msRoute = `/api/tickets/assigneeByExternalId/${externalId}`;
    const { data } = await axiosDefault.get(`${msRoute}`, {
      headers: {
        Authorization: authorizationToken
      }
    });
    return data;
  } catch (e) {
    const { code, error } = e?.response?.data;
    if (code === 422 && error.length > 0) {
      message.error(error[0].value);
    }
    throw new Error("Failed to fetch assignee");
  }
};

export const fetchBoxesMocked = (): Promise<Box[]> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const boxes = genBoxes();
      const initedBoxes = boxes.map(box => {
        const { count } = box;
        const issuePages: IssuePages = {};
        for (let i = 0; i < count; i++) {
          issuePages[i] = undefined;
        }
        return { ...box, issuePages };
      });
      resolve(initedBoxes);
    }, 1000);
  });
};

export const fecthSupervisorIssues = async (
  boxId: string,
  page: number,
  size: number,
  categories: string,
  //DELETE ME LATER

  orderBy: string,
  valueTosearh?: string
) => {
  try {
    const authorizationToken = await getAuthorization();

    const pagination = {
      page: page + 1,
      size
    };
    // TODO: all this logic should be managed in a better way from the endpoint itself
    let sort = {
      predicate: orderBy === "" ? "id" : orderBy,
      type: orderBy === "priority" ? "DESC" : "ASC"
    };

    if (boxId === "2" || boxId === "3") {
      sort = {
        predicate: "id",
        type: "DESC"
      };
    }

    const { data } = await axiosDefault.get(`/api/tickets/getAllTickets`, {
      params: {
        categories,
        filterId: boxId,
        pagination,
        sort,
        search: valueTosearh
      },
      headers: {
        Authorization: authorizationToken
      }
    });
    const tickets = data.data;
    const formattedTickets: Ticket[] = tickets.map((ticket: any) => {
      return {
        id: ticket.id,
        // TODO: poner el valor correcto cuando ya exista esa funcionalidad
        read: true,
        responsible: {
          id: ticket.assignee.id,
          name: ticket.assignee.name
        },
        author: ticket.author ?? "Anónimo",
        subject: ticket.subject,
        flowStatus: ticket.globalStatus,
        flowStatusUpdatedAt: ticket.updatedAt,
        priority: ticket.priority,
        createdAt: ticket.createdAt,
        updatedAt: ticket.updatedAt,
        score: ticket.score,
        ...ticket
      };
    });
    return formattedTickets;
  } catch (error) {
    throw new Error("Failed to fetch fetchIssues");
  }
};

export const fetchSupervisorIssuesActivities = async (
  moduleId: string,
  box: Box,
  page: number,
  size: number,
  categories: string,
  assigneeId: number,
  //DELETE ME LATER

  orderBy: string,
  valueTosearh?: string
): Promise<Issue[]> => {
  const boxId = box.id;
  const defaultParams = box.defaultParams ?? {};

  try {
    const authorizationToken = await getAuthorization();

    const pagination = {
      page: page + 1,
      size
    };
    const sort = {
      predicate: orderBy === "" ? "id" : orderBy,
      type: orderBy === "priority" ? "DESC" : "ASC"
    };
    // TODO: Cambiar a tickets por assignee
    const { data } = await axiosDefault.get<any>(
      `/api/tickets/ticketsByActivities`,
      {
        params: {
          ...defaultParams,
          filterId: boxId,
          categories,
          pagination,
          sort,
          search: valueTosearh
        },
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    const tickets = data.data;
    const formattedTickets: Ticket[] = tickets.map((ticket: any) => {
      return {
        id: ticket.id,
        // TODO: poner el valor correcto cuando ya exista esa funcionalidad
        read: true,
        responsible: {
          id: ticket.assignee.id,
          name: ticket.assignee.name
        },
        author: ticket.author ?? "Anónimo",
        subject: ticket.subject,
        flowStatus: ticket.globalStatus,
        flowStatusUpdatedAt: ticket.updatedAt,
        priority: ticket.priority,
        createdAt: ticket.createdAt,
        updatedAt: ticket.updatedAt,
        score: ticket.score,
        ...ticket
      };
    });
    return formattedTickets;
  } catch (error) {
    throw new Error("Failed to fetch fetchIssues");
  }
};
